import { Checkbox as RacCheckbox, Text } from 'react-aria-components';
import styled, { css } from 'styled-components';

const vars = css`
  --checkbox-side-length: 18px;
  --pre-label-spacing: calc(var(--checkbox-side-length) + var(--spacing-base));
`;

export const Checkbox = styled(RacCheckbox)`
  ${vars}
  display: flex;
  align-items: center;
  gap: var(--spacing-base);
  font-size: var(--font-size-text-md);
  font-weight: var(--font-size-text-md);
  color: var(--text-color);

  .checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: var(--checkbox-side-length);
    height: var(--checkbox-side-length);
    border: 1px solid var(--grey-300);
    border-radius: var(--radius-base);
    transition: all 200ms;
  }

  svg {
    fill: none;
    transition: all 200ms;

    & path {
      stroke: var(--white);
    }
  }

  &[data-pressed] .checkbox {
    border-color: var(--brand-900);
  }

  &[data-focus-visible] .checkbox {
    box-shadow: 0 0 0 2px var(--brand-100), 0 0 0 4px var(--brand-900);
    outline: 0;
  }

  &[data-selected] {
    .checkbox {
      border-color: var(--brand-900);
      background: var(--brand-900);
    }
  }
`;

export const HelpText = styled(Text)`
  ${vars}
  width: calc(100% - var(--pre-label-spacing));
  font-size: var(--font-size-text-sm);
  font-weight: var(--font-weight-regular);
  color: var(--grey-600);
  position: relative;
  top: -0.5rem;
  left: var(--pre-label-spacing);
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background: var(--white);
  border: 1px solid var(--grey-300);
  border-radius: var(--radius-base);
  padding: var(--spacing-base);

  & > span {
    top: 0;
  }
`;
